import React from 'react';
import { Size } from '../../../Enums/Size.enum';
import Modal from '../../Modal/Modal';
import { useTreatmentContext } from '../../../Services/TreatmentContext';
import CalendarEvent, { CalendarEventProps } from './CalendarEvent';
import { IResponse } from '../../../Services/ApiClient';

interface Props extends CalendarEventProps {
	isOpened: boolean;
	setIsOpened: (isOpen: boolean) => void;
	onClose?: () => void;
}

const CalendarEventModal: React.FC<Props> = ({
	isOpened,
	setIsOpened,
	type,
	onEventCreate,
	onEventEdit,
	params,
	onClose,
}) => {
	const { isCase } = useTreatmentContext();

	const handleOnEventCreate = (response: IResponse) => {
		setIsOpened(false);
		onEventCreate(response);
	};

	const handleOnEventEdit = (response: IResponse) => {
		setIsOpened(false);
		onEventEdit(response);
	};

	const handleOnClose = () => {
		setIsOpened(false);
		onClose?.();
	};

	return (
		<Modal
			opened={isOpened}
			onClose={handleOnClose}
			wrapChat={isCase}
			size={Size.LG}>
			<Modal.Header title='' />
			<Modal.Content>
				<CalendarEvent
					type={type}
					params={params}
					onEventCreate={handleOnEventCreate}
					onEventEdit={handleOnEventEdit}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default CalendarEventModal;
